const fields = [
    'CharakteristikaUzluSilnicniSite',
    'CislaKrizujicichKomunikaci',
    'CisloEtahu',
    'CisloSledovaneVodniCesty',
    'CisloUzlu',
    'DatumRekultivace',
    'Dimenze',
    'DruhDopravyLanoveDrahy',
    'DruhLetiste',
    'DruhMelioracnichOpatreni',
    'DruhSchodiste',
    'DruhStaniceRozvodneSite',
    'ElektrizaceZeleznicniTrate',
    'EvidencniCisloObjektu',
    'HraniceJinehoObjektu',
    'ICS',
    'IdObjektuDrazniStavby',
    'IdObjektuLetiste',
    'IdObjektuSilnicniStavby',
    'IdObjektuStavbyProVodniDopravu',
    'InstalovanyVykon',
    'IzolaceVenkovnihoVedeni',
    'Kapacita',
    'KapacitaCOV',
    'KapacitaCOVeo',
    'KapacitaUpravnyVody',
    'KategoriePozemniKomunikace',
    'KategorieZeleznicniTrate',
    'Material',
    'MaterialOchranyVedeniSiteEK',
    'MaximalniNapetovaHladina',
    'MaximalniProvozniNapeti',
    'MinVyskaHladinyVodojemu',
    'NazevSledovaneVodniVesty',
    'ObjemVodojemu',
    'OchrannaFunkce',
    'OznaceniCyklostezky',
    'OznaceniHeliportu',
    'OznaceniKomunikace',
    'OznaceniKomunikaceTrate',
    'OznaceniLetiste',
    'OznaceniObjektu',
    'OznaceniTrate',
    'PocetJizdnichPruhu',
    'PocetKoleji',
    'PopisBP',
    'PopisOP',
    'PopisObjektu',
    'PovoleniNakladaniNebezpecnymOdpadem',
    'PrevazujiciPovrch',
    'ProvozniNapeti',
    'PrujezdnaSirka',
    'PrujezdnaVyska',
    'Rokgeodetickehoporizeni',
    'RokVystavby',
    'RozchodKoleji',
    'StavObjektu',
    'StavSkladkyOdpadu',
    'Tlakovahladinaplynovodnisite',
    'TridaDopravNevyznamneVodniCesty',
    'TridaDopravnihoZatizeni',
    'TridaPresnosti',
    'TridaPresnostiVyska',
    'TridaPresnostiPoloha',
    'TypInzenyrskeSitePKO',
    'TypJadernehoZarizeni',
    'TypLeteckeStavby',
    'TypMediaPlynovodniSite',
    'TypMediaProduktovodu',
    'TypMediaVodovodniSite',
    'TypMostu',
    'TypNabijecihoVydejnihoMedia',
    'TypOPDrazniStavby',
    'TypOPLeteckychzabezpecovacichzarizeni',
    'TypOPLetiste',
    'TypOPOdpadovehoHospodarstvi',
    'TypOPPozemniKomunikace',
    'TypOPSiteEK',
    'TypOPSiteProduktovodu',
    'TypObjektuZarizeniOchranaPredPovodnemi',
    'TypOdpadu',
    'TypPovrchuVzletovePristavaciDrahy',
    'TypPristavu',
    'TypSledovaneVodniCesty',
    'TypStaniceRozvodneSite',
    'TypTechnologickehoObjektuPlynovodniSite',
    'TypTechnologickehoObjektuPrivadeceVody',
    'TypTechnologickehoObjektuSiteEK',
    'TypTechnologickehoObjektuTeplovodniSite',
    'TypTeplovodniSite',
    'TypTunelu',
    'TypUsekuPozemniKomunikace',
    'TypUsekuZeleznicniTrate',
    'TypVodojemu',
    'TypVrtu',
    'TypVyrobnyElektriny',
    'TypZarizeniOdstranovaniOdpadu',
    'TypZarizeniPrivadeceVody',
    'TypZarizeniProLeteckyProvoz',
    'TypZeleznicniStanice',
    'TypZeleznicniTrate',
    'UmisteniHeliportu',
    'UrovenUmisteniObjektuDI',
    'UrovenUmisteniObjektuTI',
    'VyskaNaTerenu',
    'ZarazeniSledovaneVodniCesty',
    'ZpusobPorizeniZPS',
    'ZpusobPorizeniDI',
    'ZpusobPorizeniTI',
    'ZpusobRekultivace',
];
// MUTATION
export const dmxVariables = fields.reduce((acc, value) => {
    acc += `$${value}: auto,`;
    return acc;
}, '');
export const dmxInputFields = fields.reduce((acc, value) => {
    acc += `${value}: $${value},`;
    return acc;
}, '');
// QUERY
export const dmxFields = fields.reduce((acc, value) => {
    acc += `${value}
  `;
    return acc;
}, '');
//# sourceMappingURL=dmxGqlChunks.js.map